import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labTopicEditRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/topics/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/lab/Topics/LabTopicEditPage/LabTopicEditPage').then((d) => d.Route));
